export default __webpack_public_path__ + "static/media/collapse.319355a4.svg";